import { render, staticRenderFns } from "./goSearch.vue?vue&type=template&id=0b7fd661&scoped=true&"
import script from "./goSearch.vue?vue&type=script&lang=js&"
export * from "./goSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7fd661",
  null
  
)

export default component.exports